/* =====================================================
   bizFlagUtils  —  Shared flag + country data utility
   
   Centraliza:
     - toFlag(iso2)       → emoji de bandera
     - ALL_COUNTRIES      → lista completa
     - PREFERRED_LIST     → países destacados
     - SORTED_ALL         → lista ordenada A-Z
     - COUNTRY_LENGTHS    → rangos de validación telefónica
     - getExpectedLength  → helper de validación

   bizPhoneInput y cualquier otro componente que necesite
   países/banderas deben inyectar este factory en lugar de
   definir sus propias copias locales.
   ===================================================== */
angular.module('bizmetryApp').factory('bizFlagUtils', function () {

  // ── Flag emoji from ISO-2 code ─────────────────────────────────────────
  function toFlag(iso2) {
    if (!iso2 || iso2.length !== 2) return '🌐';
    return iso2.toUpperCase().replace(/./g, function (c) {
      return String.fromCodePoint(c.charCodeAt(0) + 127397);
    });
  }

  // ── Country list ───────────────────────────────────────────────────────
  var PREFERRED_ISO2 = ['US','GB','ES','AR','MX','BR','DE','FR','CA','AU'];

  var ALL_COUNTRIES = [
    { iso2:'AF', name:'Afghanistan',          dial:'+93'   },
    { iso2:'AL', name:'Albania',              dial:'+355'  },
    { iso2:'DZ', name:'Algeria',              dial:'+213'  },
    { iso2:'AD', name:'Andorra',              dial:'+376'  },
    { iso2:'AO', name:'Angola',               dial:'+244'  },
    { iso2:'AG', name:'Antigua & Barbuda',    dial:'+1268' },
    { iso2:'AR', name:'Argentina',            dial:'+54'   },
    { iso2:'AM', name:'Armenia',              dial:'+374'  },
    { iso2:'AU', name:'Australia',            dial:'+61'   },
    { iso2:'AT', name:'Austria',              dial:'+43'   },
    { iso2:'AZ', name:'Azerbaijan',           dial:'+994'  },
    { iso2:'BS', name:'Bahamas',              dial:'+1242' },
    { iso2:'BH', name:'Bahrain',              dial:'+973'  },
    { iso2:'BD', name:'Bangladesh',           dial:'+880'  },
    { iso2:'BB', name:'Barbados',             dial:'+1246' },
    { iso2:'BY', name:'Belarus',              dial:'+375'  },
    { iso2:'BE', name:'Belgium',              dial:'+32'   },
    { iso2:'BZ', name:'Belize',               dial:'+501'  },
    { iso2:'BJ', name:'Benin',                dial:'+229'  },
    { iso2:'BT', name:'Bhutan',               dial:'+975'  },
    { iso2:'BO', name:'Bolivia',              dial:'+591'  },
    { iso2:'BA', name:'Bosnia & Herzegovina', dial:'+387'  },
    { iso2:'BW', name:'Botswana',             dial:'+267'  },
    { iso2:'BR', name:'Brazil',               dial:'+55'   },
    { iso2:'BN', name:'Brunei',               dial:'+673'  },
    { iso2:'BG', name:'Bulgaria',             dial:'+359'  },
    { iso2:'BF', name:'Burkina Faso',         dial:'+226'  },
    { iso2:'BI', name:'Burundi',              dial:'+257'  },
    { iso2:'KH', name:'Cambodia',             dial:'+855'  },
    { iso2:'CM', name:'Cameroon',             dial:'+237'  },
    { iso2:'CA', name:'Canada',               dial:'+1'    },
    { iso2:'CV', name:'Cape Verde',           dial:'+238'  },
    { iso2:'CF', name:'Central African Rep.', dial:'+236'  },
    { iso2:'TD', name:'Chad',                 dial:'+235'  },
    { iso2:'CL', name:'Chile',                dial:'+56'   },
    { iso2:'CN', name:'China',                dial:'+86'   },
    { iso2:'CO', name:'Colombia',             dial:'+57'   },
    { iso2:'KM', name:'Comoros',              dial:'+269'  },
    { iso2:'CG', name:'Congo',                dial:'+242'  },
    { iso2:'CR', name:'Costa Rica',           dial:'+506'  },
    { iso2:'HR', name:'Croatia',              dial:'+385'  },
    { iso2:'CU', name:'Cuba',                 dial:'+53'   },
    { iso2:'CY', name:'Cyprus',               dial:'+357'  },
    { iso2:'CZ', name:'Czech Republic',       dial:'+420'  },
    { iso2:'DK', name:'Denmark',              dial:'+45'   },
    { iso2:'DJ', name:'Djibouti',             dial:'+253'  },
    { iso2:'DO', name:'Dominican Republic',   dial:'+1809' },
    { iso2:'EC', name:'Ecuador',              dial:'+593'  },
    { iso2:'EG', name:'Egypt',                dial:'+20'   },
    { iso2:'SV', name:'El Salvador',          dial:'+503'  },
    { iso2:'GQ', name:'Equatorial Guinea',    dial:'+240'  },
    { iso2:'ER', name:'Eritrea',              dial:'+291'  },
    { iso2:'EE', name:'Estonia',              dial:'+372'  },
    { iso2:'ET', name:'Ethiopia',             dial:'+251'  },
    { iso2:'FJ', name:'Fiji',                 dial:'+679'  },
    { iso2:'FI', name:'Finland',              dial:'+358'  },
    { iso2:'FR', name:'France',               dial:'+33'   },
    { iso2:'GA', name:'Gabon',                dial:'+241'  },
    { iso2:'GM', name:'Gambia',               dial:'+220'  },
    { iso2:'GE', name:'Georgia',              dial:'+995'  },
    { iso2:'DE', name:'Germany',              dial:'+49'   },
    { iso2:'GH', name:'Ghana',                dial:'+233'  },
    { iso2:'GR', name:'Greece',               dial:'+30'   },
    { iso2:'GT', name:'Guatemala',            dial:'+502'  },
    { iso2:'GN', name:'Guinea',               dial:'+224'  },
    { iso2:'GW', name:'Guinea-Bissau',        dial:'+245'  },
    { iso2:'GY', name:'Guyana',               dial:'+592'  },
    { iso2:'HT', name:'Haiti',                dial:'+509'  },
    { iso2:'HN', name:'Honduras',             dial:'+504'  },
    { iso2:'HK', name:'Hong Kong',            dial:'+852'  },
    { iso2:'HU', name:'Hungary',              dial:'+36'   },
    { iso2:'IS', name:'Iceland',              dial:'+354'  },
    { iso2:'IN', name:'India',                dial:'+91'   },
    { iso2:'ID', name:'Indonesia',            dial:'+62'   },
    { iso2:'IR', name:'Iran',                 dial:'+98'   },
    { iso2:'IQ', name:'Iraq',                 dial:'+964'  },
    { iso2:'IE', name:'Ireland',              dial:'+353'  },
    { iso2:'IL', name:'Israel',               dial:'+972'  },
    { iso2:'IT', name:'Italy',                dial:'+39'   },
    { iso2:'JM', name:'Jamaica',              dial:'+1876' },
    { iso2:'JP', name:'Japan',                dial:'+81'   },
    { iso2:'JO', name:'Jordan',               dial:'+962'  },
    { iso2:'KZ', name:'Kazakhstan',           dial:'+7'    },
    { iso2:'KE', name:'Kenya',                dial:'+254'  },
    { iso2:'KW', name:'Kuwait',               dial:'+965'  },
    { iso2:'KG', name:'Kyrgyzstan',           dial:'+996'  },
    { iso2:'LA', name:'Laos',                 dial:'+856'  },
    { iso2:'LV', name:'Latvia',               dial:'+371'  },
    { iso2:'LB', name:'Lebanon',              dial:'+961'  },
    { iso2:'LS', name:'Lesotho',              dial:'+266'  },
    { iso2:'LR', name:'Liberia',              dial:'+231'  },
    { iso2:'LY', name:'Libya',                dial:'+218'  },
    { iso2:'LI', name:'Liechtenstein',        dial:'+423'  },
    { iso2:'LT', name:'Lithuania',            dial:'+370'  },
    { iso2:'LU', name:'Luxembourg',           dial:'+352'  },
    { iso2:'MO', name:'Macao',                dial:'+853'  },
    { iso2:'MK', name:'North Macedonia',      dial:'+389'  },
    { iso2:'MG', name:'Madagascar',           dial:'+261'  },
    { iso2:'MW', name:'Malawi',               dial:'+265'  },
    { iso2:'MY', name:'Malaysia',             dial:'+60'   },
    { iso2:'MV', name:'Maldives',             dial:'+960'  },
    { iso2:'ML', name:'Mali',                 dial:'+223'  },
    { iso2:'MT', name:'Malta',                dial:'+356'  },
    { iso2:'MR', name:'Mauritania',           dial:'+222'  },
    { iso2:'MU', name:'Mauritius',            dial:'+230'  },
    { iso2:'MX', name:'Mexico',               dial:'+52'   },
    { iso2:'MD', name:'Moldova',              dial:'+373'  },
    { iso2:'MC', name:'Monaco',               dial:'+377'  },
    { iso2:'MN', name:'Mongolia',             dial:'+976'  },
    { iso2:'ME', name:'Montenegro',           dial:'+382'  },
    { iso2:'MA', name:'Morocco',              dial:'+212'  },
    { iso2:'MZ', name:'Mozambique',           dial:'+258'  },
    { iso2:'MM', name:'Myanmar',              dial:'+95'   },
    { iso2:'NA', name:'Namibia',              dial:'+264'  },
    { iso2:'NP', name:'Nepal',                dial:'+977'  },
    { iso2:'NL', name:'Netherlands',          dial:'+31'   },
    { iso2:'NZ', name:'New Zealand',          dial:'+64'   },
    { iso2:'NI', name:'Nicaragua',            dial:'+505'  },
    { iso2:'NE', name:'Niger',                dial:'+227'  },
    { iso2:'NG', name:'Nigeria',              dial:'+234'  },
    { iso2:'NO', name:'Norway',               dial:'+47'   },
    { iso2:'OM', name:'Oman',                 dial:'+968'  },
    { iso2:'PK', name:'Pakistan',             dial:'+92'   },
    { iso2:'PA', name:'Panama',               dial:'+507'  },
    { iso2:'PG', name:'Papua New Guinea',     dial:'+675'  },
    { iso2:'PY', name:'Paraguay',             dial:'+595'  },
    { iso2:'PE', name:'Peru',                 dial:'+51'   },
    { iso2:'PH', name:'Philippines',          dial:'+63'   },
    { iso2:'PL', name:'Poland',               dial:'+48'   },
    { iso2:'PT', name:'Portugal',             dial:'+351'  },
    { iso2:'QA', name:'Qatar',                dial:'+974'  },
    { iso2:'RO', name:'Romania',              dial:'+40'   },
    { iso2:'RU', name:'Russia',               dial:'+7'    },
    { iso2:'RW', name:'Rwanda',               dial:'+250'  },
    { iso2:'SA', name:'Saudi Arabia',         dial:'+966'  },
    { iso2:'SN', name:'Senegal',              dial:'+221'  },
    { iso2:'RS', name:'Serbia',               dial:'+381'  },
    { iso2:'SL', name:'Sierra Leone',         dial:'+232'  },
    { iso2:'SG', name:'Singapore',            dial:'+65'   },
    { iso2:'SK', name:'Slovakia',             dial:'+421'  },
    { iso2:'SI', name:'Slovenia',             dial:'+386'  },
    { iso2:'SO', name:'Somalia',              dial:'+252'  },
    { iso2:'ZA', name:'South Africa',         dial:'+27'   },
    { iso2:'KR', name:'South Korea',          dial:'+82'   },
    { iso2:'SS', name:'South Sudan',          dial:'+211'  },
    { iso2:'ES', name:'Spain',                dial:'+34'   },
    { iso2:'LK', name:'Sri Lanka',            dial:'+94'   },
    { iso2:'SD', name:'Sudan',                dial:'+249'  },
    { iso2:'SR', name:'Suriname',             dial:'+597'  },
    { iso2:'SE', name:'Sweden',               dial:'+46'   },
    { iso2:'CH', name:'Switzerland',          dial:'+41'   },
    { iso2:'SY', name:'Syria',                dial:'+963'  },
    { iso2:'TW', name:'Taiwan',               dial:'+886'  },
    { iso2:'TJ', name:'Tajikistan',           dial:'+992'  },
    { iso2:'TZ', name:'Tanzania',             dial:'+255'  },
    { iso2:'TH', name:'Thailand',             dial:'+66'   },
    { iso2:'TL', name:'Timor-Leste',          dial:'+670'  },
    { iso2:'TG', name:'Togo',                 dial:'+228'  },
    { iso2:'TT', name:'Trinidad & Tobago',    dial:'+1868' },
    { iso2:'TN', name:'Tunisia',              dial:'+216'  },
    { iso2:'TR', name:'Turkey',               dial:'+90'   },
    { iso2:'TM', name:'Turkmenistan',         dial:'+993'  },
    { iso2:'UG', name:'Uganda',               dial:'+256'  },
    { iso2:'UA', name:'Ukraine',              dial:'+380'  },
    { iso2:'AE', name:'United Arab Emirates', dial:'+971'  },
    { iso2:'GB', name:'United Kingdom',       dial:'+44'   },
    { iso2:'US', name:'United States',        dial:'+1'    },
    { iso2:'UY', name:'Uruguay',              dial:'+598'  },
    { iso2:'UZ', name:'Uzbekistan',           dial:'+998'  },
    { iso2:'VE', name:'Venezuela',            dial:'+58'   },
    { iso2:'VN', name:'Vietnam',              dial:'+84'   },
    { iso2:'YE', name:'Yemen',                dial:'+967'  },
    { iso2:'ZM', name:'Zambia',               dial:'+260'  },
    { iso2:'ZW', name:'Zimbabwe',             dial:'+263'  }
  ];

  // Pre-compute flag emoji once for all entries
  ALL_COUNTRIES.forEach(function (c) { c.flag = toFlag(c.iso2); });

  var PREFERRED_LIST = PREFERRED_ISO2
    .map(function (iso2) { return ALL_COUNTRIES.find(function (c) { return c.iso2 === iso2; }); })
    .filter(Boolean);

  var SORTED_ALL = ALL_COUNTRIES.slice().sort(function (a, b) { return a.name.localeCompare(b.name); });

  // ── Phone number length ranges [min, max] ─────────────────────────────
  var COUNTRY_LENGTHS = {
    'US':[10,10], 'CA':[10,10], 'MX':[10,10],
    'AG':[10,10], 'BB':[10,10], 'BS':[10,10], 'DM':[10,10],
    'DO':[10,10], 'GD':[10,10], 'JM':[10,10], 'KN':[10,10],
    'LC':[10,10], 'TT':[10,10], 'VC':[10,10],
    'GB':[10,10], 'DE':[10,11], 'FR':[9,9],   'ES':[9,9],
    'IT':[9,10],  'PT':[9,9],   'NL':[9,9],   'BE':[8,9],
    'CH':[9,9],   'AT':[10,11], 'SE':[9,9],   'NO':[8,8],
    'DK':[8,8],   'FI':[9,10],  'PL':[9,9],   'CZ':[9,9],
    'SK':[9,9],   'HU':[9,9],   'RO':[9,9],   'BG':[9,9],
    'HR':[8,9],   'RS':[9,9],   'SI':[8,8],   'GR':[10,10],
    'IE':[9,9],   'LU':[9,9],   'IS':[7,7],   'LT':[8,8],
    'LV':[8,8],   'EE':[7,8],   'AL':[9,9],   'BA':[8,8],
    'ME':[8,8],   'MK':[8,8],   'MD':[8,8],   'BY':[9,9],
    'UA':[9,9],   'RU':[10,10], 'AM':[8,8],   'AZ':[9,9],
    'GE':[9,9],   'LI':[7,9],   'AD':[6,9],   'MC':[8,9],
    'MT':[8,8],   'CY':[8,8],
    'AR':[10,10], 'BR':[10,11], 'CO':[10,10], 'CL':[9,9],
    'PE':[9,9],   'VE':[10,10], 'EC':[9,9],   'BO':[8,8],
    'PY':[9,9],   'UY':[9,9],   'CR':[8,8],   'PA':[8,8],
    'GT':[8,8],   'HN':[8,8],   'SV':[8,8],   'NI':[8,8],
    'CU':[8,8],   'HT':[8,8],   'GY':[7,7],   'SR':[7,7],
    'SA':[9,9],   'AE':[9,9],   'IL':[9,9],   'JO':[9,9],
    'LB':[8,8],   'SY':[9,9],   'IQ':[10,10], 'IR':[10,10],
    'KW':[8,8],   'QA':[8,8],   'BH':[8,8],   'OM':[8,8],
    'YE':[9,9],
    'IN':[10,10], 'CN':[11,11], 'JP':[10,10], 'KR':[10,11],
    'ID':[9,12],  'PH':[10,10], 'VN':[9,10],  'TH':[9,9],
    'MY':[9,10],  'SG':[8,8],   'HK':[8,8],   'TW':[9,9],
    'PK':[10,10], 'BD':[10,10], 'LK':[9,9],   'NP':[10,10],
    'AU':[9,9],   'NZ':[9,9],   'MN':[8,8],   'KH':[8,9],
    'MM':[9,10],  'LA':[8,10],  'BT':[8,8],   'MV':[7,7],
    'AF':[9,9],   'TJ':[9,9],   'TM':[8,8],   'UZ':[9,9],
    'KZ':[10,10], 'KG':[9,9],
    'NG':[10,10], 'ZA':[9,9],   'EG':[10,10], 'KE':[9,9],
    'ET':[9,9],   'GH':[9,9],   'TZ':[9,9],   'SN':[9,9],
    'MA':[9,9],   'DZ':[9,9],   'TN':[8,8],   'LY':[9,9],
    'CM':[9,9],   'CI':[10,10], 'MG':[9,9],   'ZM':[9,9],
    'ZW':[9,9],   'AO':[9,9],   'MZ':[9,9],   'UG':[9,9],
    'RW':[9,9],   'SD':[9,9],   'SO':[8,9],   'CD':[9,9],
    'BJ':[8,8],   'BF':[8,8],   'ML':[8,8],   'NE':[8,8],
    'TD':[8,8],   'CF':[8,8],   'GA':[7,8],   'CG':[9,9],
    'GN':[9,9],   'GW':[7,7],   'SL':[8,8],   'LR':[7,8],
    'GM':[7,7],   'LS':[8,8],   'BW':[8,8],   'NA':[9,9],
    'SS':[9,9],   'ER':[7,7],   'DJ':[8,8],   'BI':[8,8],
    'KM':[7,7],   'MU':[8,8],   'CV':[7,7],   'GQ':[9,9],
    'TR':[10,10], 'TL':[8,8],   'FJ':[7,7],   'PG':[8,8],
    'BN':[7,7]
  };

  var DEFAULT_LENGTH = [7, 12];

  // ── Public API ─────────────────────────────────────────────────────────
  return {
    toFlag:            toFlag,
    ALL_COUNTRIES:     ALL_COUNTRIES,
    PREFERRED_LIST:    PREFERRED_LIST,
    SORTED_ALL:        SORTED_ALL,
    COUNTRY_LENGTHS:   COUNTRY_LENGTHS,
    getExpectedLength: function (iso2) {
      return COUNTRY_LENGTHS[iso2] || DEFAULT_LENGTH;
    }
  };

});